/* NBD-BUYNOW-GUARD-2026-09-07
   ---------------------------------------------------------------------------
   Buy Now / Instant Checkout must mean "buy exactly this, now" — not "add this
   to whatever is already in the cart".

   THE BUG THIS FIXES (founder-reported, 7 Sept 2026, seen in a real abandoned
   checkout with 2 Imperial belts):
     Buy Now with 2 belts  ->  lands on /checkout
     customer presses BACK ->  back on the product page
     Buy Now with 3 belts  ->  checkout now shows FIVE belts

   Every NBD product section does the same thing:
       fetch('/cart/add.js', …).then(function(){ location.href = '/checkout'; })
   /cart/add.js ADDS to the existing cart, and the first attempt's lines are
   still sitting there. 33 live sections share this shape.

   HOW THIS FIXES IT, once, for all of them:
   The guard wraps window.fetch. When a POST to /cart/add.js comes from a Buy Now
   handler, it lets the add happen and then RECONCILES: every cart line belonging
   to the same product(s) is set to exactly the quantity the Buy Now asked for,
   and any leftover line of that product (a stale quantity, or a different size
   chosen on the earlier attempt) is removed.

   WHAT IT DELIBERATELY DOES NOT DO:
   - It never clears the cart. Frequently-bought-together accessories, and
     anything the customer added from another product, are untouched — only the
     product being bought right now is reconciled.
   - It never touches a plain "Add to Cart". Adding the same belt twice on
     purpose still gives you two.

   IDENTIFYING A BUY NOW: the call stack. Every section names its handler
   nbdBuyNow / nbdImperialBuyNow / packCheckout etc. If the stack does not
   clearly say Buy Now, the guard stays out of the way and the add behaves
   exactly as before — failing open, never closed.
   --------------------------------------------------------------------------- */
(function () {
  if (window.__nbdBuyNowGuard) return;
  window.__nbdBuyNowGuard = '2026-09-07';

  var origFetch = window.fetch;
  if (typeof origFetch !== 'function') return;

  var BUYNOW_RE = /buy\s*now|buynow|buy_now|instant\s*checkout|packcheckout/i;

  function stackSaysBuyNow() {
    try { throw new Error('nbd'); }
    catch (e) { return BUYNOW_RE.test(String(e.stack || '')); }
  }

  /* Pull {variantId: qty} out of whatever shape the section posted. */
  function wantedFrom(body) {
    if (!body || typeof body !== 'string') return null;
    var data;
    try { data = JSON.parse(body); } catch (e) { return null; }
    var out = {}, any = false;
    function take(o) {
      if (!o) return;
      var id = parseInt(o.id, 10);
      var q = parseInt(o.quantity, 10);
      if (!id) return;
      if (!q || q < 1) q = 1;
      out[id] = (out[id] || 0) + q;
      any = true;
    }
    if (Array.isArray(data.items)) data.items.forEach(take);
    else take(data);
    return any ? out : null;
  }

  function getJSON(url, opts) {
    return origFetch.call(window, url, opts).then(function (r) {
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  /* After the add lands, force the cart to hold exactly `wanted` for the
     products involved, and nothing stale of those products. */
  function reconcile(wanted) {
    return getJSON('/cart.js', { credentials: 'same-origin' }).then(function (cart) {
      var items = cart && cart.items ? cart.items : [];

      /* Which products is this Buy Now about? Learn it from the cart lines we
         just created — that is the only place the product_id is available. */
      var targetProducts = {};
      items.forEach(function (li) {
        if (wanted[li.id] != null) targetProducts[li.product_id] = true;
      });
      if (!Object.keys(targetProducts).length) return null;

      var updates = {}, changed = false;
      items.forEach(function (li) {
        if (!targetProducts[li.product_id]) return;      // other products: untouched
        var want = wanted[li.id] || 0;                   // 0 removes a stale line
        if (li.quantity !== want) { updates[li.id] = want; changed = true; }
      });
      if (!changed) return null;

      return origFetch.call(window, '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    });
  }

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var isAdd = method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(String(url));

    if (!isAdd) return origFetch.apply(this, arguments);

    var wanted = init ? wantedFrom(init.body) : null;
    var buyNow = stackSaysBuyNow();
    var p = origFetch.apply(this, arguments);

    if (!buyNow || !wanted) return p;   // plain Add to Cart — behave exactly as before

    return p.then(function (res) {
      if (!res || !res.ok) return res;
      return reconcile(wanted)
        .then(function () { return res; })
        .catch(function (err) {
          /* Never block the sale: if reconciliation fails the customer still
             reaches checkout, just with the old accumulating behaviour. */
          if (window.console && console.warn) console.warn('[nbd-buynow-guard]', err);
          return res;
        });
    });
  };
})();
